import React from 'react';

import { List } from '../../components';
import { ListContainer } from '../../containers';

import ServiceRunDetailMachineListItem from './ServiceRunDetailMachineListItem';

const ServiceRunDetailMachineListRaw = ({
	items,
	showControls = true,
	removeTopMargin = false,
}) => {

	return (
		<List
			items={items}
			listItemComponent={ServiceRunDetailMachineListItem}
			showControls={showControls}
			removeTopMargin={removeTopMargin}
		/>
	);
};

const ServiceRunDetailMachineList = ListContainer(ServiceRunDetailMachineListRaw);

const ServiceRunDetailMachineListView = ({
	items,
	showControls = true,
	removeTopMargin = false,
}) => {
	return (
		<ServiceRunDetailMachineList
			frontEnd={true}
			items={items}
			showControls={showControls}
			removeTopMargin={removeTopMargin}
			filterFields={[
				item => item.machine?.location?.name,
				item => item.machine?.place?.name,
				item => item.machine?.assetId,
			]}
		/>
	);
};



export default ServiceRunDetailMachineListView;
